/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-10-09 14:07:08
 * @version 1.0.0
 */
import React from 'react';

import {
  HOME_ANSWER_AGREE_ACTION_TYPE,
  HOME_ANSWER_DISAGREE_ACTION_TYPE,
  HOME_TAB_KEY_FOLLOW
} from '@src/utils/constant/home';
import { classnames, getValueDepth1, openTargetBlankPage } from '@src/utils';
import { FollowQuestionOrAnswerInfo, AnswerSimpleInfo } from '@src/services';
import { SFCItemOption } from '@src/features/common/components';
import { IconFont } from '@src/features/common/Icon';
import SFCTitleContent from '../../common/components/SFCTitleContent';

interface Props {
  data: AnswerSimpleInfo & FollowQuestionOrAnswerInfo;
  index: number;
  tabKey?: string;
  onAgreeDisagreeAnswer: (data: {
    answerId: number;
    index: number;
    clickedType: string;
    currentType: number;
  }) => void;
  showOption?: boolean;
  openTargePage: (targetUri: string) => void;
  handleRemove?: () => void;
  /** 是否需要置顶 */
  pinned?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
}

import './SFCAnswerTextImage.less';

const SFCAnswerTextImage: React.SFC<Props> = (props: Props) => {
  const {
    data,
    index,
    onAgreeDisagreeAnswer,
    tabKey,
    openTargePage,
    showOption,
    handleRemove,
    isAdmin = false,
    pinned = false
  } = props;

  const onAnswer = () => {
    openTargePage(`/ask/info/${data.questionId}`);
  };

  const onProfile = () => {
    openTargePage(`/personal/${data?.user?.username}`);
  };

  const onAgree = () => {
    onAgreeDisagreeAnswer({
      answerId: data.answerId || 0,
      index,
      clickedType: HOME_ANSWER_AGREE_ACTION_TYPE,
      currentType: data.agreeStatus || 0
    });
  };

  const onDisagree = () => {
    onAgreeDisagreeAnswer({
      answerId: data.answerId || 0,
      index,
      clickedType: HOME_ANSWER_DISAGREE_ACTION_TYPE,
      currentType: data.agreeStatus || 0
    });
  };

  const actionTypeMap = {
    2: {
      text: (
        <>
          <span
            className="k-tech-hover-underscore k-tech-cursor-pointer"
            onClick={onProfile}
          >{`${getValueDepth1(data.user, 'name')}`}</span>{' '}
          的回答
        </>
      )
    },
    3: {
      text: (
        <>
          <span
            className="k-tech-hover-underscore k-tech-cursor-pointer"
            onClick={onProfile}
          >{`${getValueDepth1(data.user, 'name')}`}</span>{' '}
          赞同过的回答
        </>
      )
    },
    5: {
      text: (
        <>
          <span
            className="k-tech-hover-underscore k-tech-cursor-pointer"
            onClick={onProfile}
          >{`${getValueDepth1(data.user, 'name')}`}</span>{' '}
          评论过的回答
        </>
      )
    },
    9: { text: `${data.actionCommonInfo}标签的回答` },
    10: { text: '你关注的提问' }
  };

  return (
    <div className="k-tech-feed-item k-tech-com-answer-text-image">
      {tabKey === HOME_TAB_KEY_FOLLOW && (
        <div className="tip">
          {!!data.actionType &&
            !!actionTypeMap[data.actionType] &&
            actionTypeMap[data.actionType].text}
        </div>
      )}
      <div className="k-tech-cursor-pointer" onClick={onAnswer}>
        <SFCTitleContent
          title={data.title || ''}
          content={data.subContent || ''}
          pinned={pinned}
          isAdmin={isAdmin}
        />
      </div>

      <div className="bottom">
        <div className="meta">
          <span className="k-tech-hover-underscore k-tech-cursor-pointer name" onClick={onProfile}>
            {data?.user?.name}
          </span>
        </div>

        <ul className="action__wrapper">
          <li
            className={classnames('k-tech-cursor-pointer', 'action', {
              'action--active': data.agreeStatus === 1
            })}
            onClick={onAgree}
          >
            <IconFont type="icon-arrow-up" className="icon" />
            赞同 {data.agreeCount || 0}
          </li>

          <li
            className={classnames('k-tech-cursor-pointer', 'action', 'action--disagree', {
              'action--active': data.agreeStatus === 2
            })}
            onClick={onDisagree}
          >
            <IconFont type="icon-arrow-down" className="icon" />
          </li>
        </ul>

        {showOption && (
          <SFCItemOption
            className="anwser_option"
            handleRemove={() => {
              handleRemove && handleRemove();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(SFCAnswerTextImage);
